import Logo from 'assets/images/logo.png';
import Socials from '../Socials';

const Footer = () => {
    return (
        <div className='pt-6'>
            <div className='flex items-center flex-col gap-4 pb-2'>
                <div>
                    <img 
                    src={Logo} 
                    alt="logo" 
                    className='sm:w-full w-[100px]'
                    />
                </div>
                <div className="flex flex-col gap-6 mt-8 text-center px-4">
                    <p className='sm:text-base text-sm'>High level experience with Digital marketing agency, to make products publicity.</p>
                    <div>
                        <button className="btn-secondary py-2">Contact Us</button>
                    </div>
                </div>
                <div>
                    <Socials />
                </div>
            </div>
            <div className="wave-container">
                <svg viewBox="0 0 1440 320">
                    <path fill="url(#waveGradient)" d="M0,96L40,117.3C80,139,160,181,240,186.7C320,192,400,160,480,138.7C560,117,640,107,720,117.3C800,128,880,160,960,165.3C1040,171,1120,149,1200,138.7C1280,128,1360,128,1400,128L1440,128L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
                    
                    <defs>
                    <linearGradient id="waveGradient" gradientTransform="rotate(90)">
                    
                        <stop offset="0" stopColor="rgba(255, 93, 0, 0.6)"></stop>
                        <stop offset="55.5" stopColor="rgba(207, 42, 109, 0.6)"></stop>
                        <stop offset="1" stopColor="rgba(167, 0, 199, 0.6)"></stop>
                    </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>
    )
}

export default Footer